export const queryKeys = {
  auth: {
    me: ['auth', 'me'] as const,
    profile: ['auth', 'profile'] as const,
  },
  campaigns: {
    all: ['campaigns'] as const,
    detail: (id: number | string) => ['campaigns', String(id)] as const,
  },
  characters: {
    all: ['characters'] as const,
  },
  worldElements: {
    all: (query?: Record<string, unknown>) => ['world-elements', query ?? {}] as const,
    characters: ['world-elements', 'characters'] as const,
  },
  narrators: {
    available: (query?: Record<string, unknown>) => ['narrators', 'available', query ?? {}] as const,
  },
  tableRounds: {
    all: ['table-rounds'] as const,
    detail: (id: number | string) => ['table-rounds', String(id)] as const,
  },
  coins: {
    balance: ['coins', 'balance'] as const,
  },
  sync: {
    cursor: ['sync', 'cursor'] as const,
    changes: (since: number, limit: number) => ['sync', 'changes', since, limit] as const,
  },
  // W4-C: Entdecken laeuft NUR ueber react-query (nie Dexie, Karte E §d).
  // Der Listen-Key traegt den kompletten Filter, damit ein Filterwechsel eine
  // eigene Query ist (staleTime 60 s greift dann je Filter).
  discover: {
    all: ['discover'] as const,
    list: (filter?: Record<string, unknown>) => ['discover', 'list', filter ?? {}] as const,
    detail: (id: number | string) => ['discover', 'detail', String(id)] as const,
  },
  // W4-C: Veroeffentlichungs-Zustand eines eigenen Charakters (PublishDialog,
  // von W4-B in der Profilansicht wiederverwendet).
  publication: {
    detail: (id: number | string) => ['publication', String(id)] as const,
  },
  // W5-D: Medien einer Figur (Bilderreihe, Highlights, Status-Schalter).
  characterMedia: {
    images: (id: number | string) => ['character-media', 'images', String(id)] as const,
    job: (id: number | string, jobId: number | string) =>
      ['character-media', 'job', String(id), String(jobId)] as const,
    highlights: (id: number | string) => ['character-media', 'highlights', String(id)] as const,
    status: (id: number | string) => ['character-media', 'status', String(id)] as const,
  },
  // W6-C: Meldungen (Proaktivitaet) + Auftraege je Figur.
  characterProactivity: {
    settings: (id: number | string) => ['character-proactivity', String(id)] as const,
  },
  characterSchedules: {
    list: (id: number | string) => ['character-schedules', String(id)] as const,
  },
  chatBackground: {
    // Galerie-Manifest (public, 24h staleTime).
    gallery: () => ['chat-background', 'gallery'] as const,
    // Slot-State je Chat-Typ/Instanz + Library (auth, kurze staleTime).
    state: (chatType: string | null | undefined, chatId: number | string | null | undefined, includeLibrary?: boolean) =>
      ['chat-background', 'state', String(chatType ?? ''), String(chatId ?? ''), includeLibrary ? 'with-library' : 'no-library'] as const,
  },
  // M6: Mitgliedschafts-Snapshot (5 Minuten staleTime, eine Quelle).
  membership: {
    snapshot: () => ['membership', 'snapshot'] as const,
    prices: () => ['membership', 'prices'] as const,
    recommendation: () => ['membership', 'recommendation'] as const,
  },
  // P2: Hinweis-System (Member-Promo). Snapshot (Regeln + State + intro_due).
  promo: {
    snapshot: () => ['promo', 'snapshot'] as const,
  },
} as const;
